import {GOAL_PLACEHOLDER_IMAGES} from '../../constants'

const getRandomPlaceholderImage = () =>
  GOAL_PLACEHOLDER_IMAGES[
    Math.floor(Math.random() * GOAL_PLACEHOLDER_IMAGES.length)
  ]

export {getRandomPlaceholderImage}
